import React, {useState, useEffect} from "react";
import {connect} from "react-redux";

import {setEventDate, setShowFutureEvents} from "../redux/actions";

const CreateDay = ({day, ...props}) => {
  // {day, setEventDateToState, eventDate, daysOfEvents, parsedEventList}
  const [hasGame, setHasGame] = useState(false);
  const [hasPractice, setHasPractice] = useState(false);
  const [hasMeeting, setHasMeeting] = useState(false);
  const [hasEvent, setHasEvent] = useState(false);
  const [hasVolunteer, setHasVolunteer] = useState(false);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const thisDay = new Date(day[2]);
  const datesEqual = today.getTime() === thisDay.getTime();
  const dateString = `${thisDay.getFullYear()}-${String(thisDay.getMonth() + 1).padStart(2, '0')}-${String(thisDay.getDate()).padStart(2, '0')}`;
  let isMarked;
  if (!!props.eventDate) {
    isMarked = dateString === props.eventDate;
  } else {
    isMarked = false;
  }

  const setEventDate = () => {
    props.setEventDate(dateString);
  };

  useEffect(() => {
    if (props.parsedEventList !== null) {
      let daysEvents = props.parsedEventList[dateString];
      if (daysEvents !== undefined) {
        let timeKeys = Object.keys(daysEvents);
        const gameTypes = new Set()
        timeKeys.forEach((time) => daysEvents[time].forEach(event =>
          gameTypes.add(event['event_type'])
        ))

        gameTypes.forEach((eventType) => {
          switch (eventType) {
            case "practice":
              setHasPractice(true);
              break;
            case "meeting":
              setHasMeeting(true);
              break;
            case "tba_game":
            case "game":
              setHasGame(true);
              break;
            // The default below would already light the generic dot, but a day
            // whose only entry is a shift deserves to say so.
            case "volunteer":
              setHasVolunteer(true);
              break;
            default:
              setHasEvent(true);
          }
        });
      }
    }
  }, [props.parsedEventList]);

  return (
    <div
      onClick={() => {
        setEventDate();
        props.setShowFutureEvents();
      }}
      className={`col day${!day[0] ? " notCurrMonth" : ""}${
        datesEqual ? " today" : ""
      }${isMarked ? " selected" : ""}${
        props.daysOfEvents.includes(dateString) ? " hasEvents" : ""
      }`}
      data-date={dateString}
    >
      <span>{day[1]}</span>
      <div className="EventIndicator-Container">
        {hasGame ? <div className="EventIndicator game"></div> : null}
        {hasPractice ? <div className="EventIndicator practice"></div> : null}
        {hasMeeting ? <div className="EventIndicator meeting"></div> : null}
        {hasEvent ? <div className="EventIndicator event"></div> : null}
        {hasVolunteer ? <div className="EventIndicator volunteer"></div> : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  eventDate: state.calendarEvents.eventDate,
  daysOfEvents: state.calendarEvents.daysOfEvents,
  parsedEventList: state.calendarEvents.parsedEventList,
});

const mapDispatchToProps = {
  setEventDate,
  setShowFutureEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDay);
